const { id, log } = require("../std/index")


//
// Locality Chooser
//
// Basically an instance of Chosen with some redirect behaviour
//

module.exports = class LocalityChooser {
  constructor($host, config) {
    const $select = $('select', $host);

    if (config.mode === 'shopify') {
      $select.on('change', function() {
        window.location = this.value;
      });
    } else {
      $select.on('change', () => $host.submit());
    }

    $select.chosen({
      disable_search_threshold: 100
    });
  }
};
